import { render, staticRenderFns } from "./AssignRole.vue?vue&type=template&id=415a7e4e&scoped=true"
import script from "./AssignRole.vue?vue&type=script&lang=js"
export * from "./AssignRole.vue?vue&type=script&lang=js"
import style0 from "./AssignRole.vue?vue&type=style&index=0&id=415a7e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a7e4e",
  null
  
)

export default component.exports